
<ng-container *ngIf="this.globals.Session">
    <app-view (viewSelectedChanged)="onViewChange($event)" (showSideBar)="toggleSidebar($event)" [refreshView]="refreshView" [profileView]="isProfile"></app-view>
</ng-container>
<div *ngIf="this.globals.Session">
  <div [ngClass]="{'primary-content' : true, 'pad': smallPad, 'full-pad' : true}">
    <div>
      <app-searchbar (keywordChanged)='onSearchKeywordChange($event)' [keyword]='searchKeyword' [profileView]="isProfile"></app-searchbar>
      <div [ngClass]="{'profile-detail': true, 'open' : true, 'custom-scrollbar': true }">
        <app-detail #detail [setComponentId]='selectedDetailId' [documentType]='selectedDetailType' 
        (selectedSubItemId)="onSelectedSubItemId($event)" (selectedSubItemType)="onSelectedSubItemType($event)"></app-detail>
      </div>
    </div>
  </div>
</div>
